export function downloadBlob(blob: Blob, filename: string) {
  const wnd = window as any;

  //Safari/WebView support
  if (
    wnd.webkit &&
    wnd.webkit.messageHandlers &&
    wnd.webkit.messageHandlers.downloadBlob
  ) {
    const reader = new FileReader();
    reader.onloadend = () => {
      wnd.webkit.messageHandlers.downloadBlob.postMessage({
        data: reader.result,
        filename: filename,
      });
    };
    reader.readAsDataURL(blob);
    return;
  }

  //All other browsers
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = filename;

  link.click();

  window.URL.revokeObjectURL(url);

  link.remove();
}
